import {
  PreferredContactMethodEnum,
  PrimaryContactForEnum,
} from 'api/backofficeApiClient';

/** UI-only sentinel for the "All" option (not sent to BE). */
export const CONTACT_FOR_ALL_UI_VALUE = 0;

export const ALL_CONTACT_FOR_VALUES: PrimaryContactForEnum[] = [
  PrimaryContactForEnum.Pricing,
  PrimaryContactForEnum.Contracts,
  PrimaryContactForEnum.Onboarding,
  PrimaryContactForEnum.Timekeeping,
  PrimaryContactForEnum.CustomerEscalations,
  PrimaryContactForEnum.WorkerEscalations,
  PrimaryContactForEnum.Invoicing,
  PrimaryContactForEnum.ProfitReporting,
  PrimaryContactForEnum.Collections,
  PrimaryContactForEnum.Technology,
  PrimaryContactForEnum.Implementation,
];

const preferredContactMethodLabels: Record<PreferredContactMethodEnum, string> =
  {
    [PreferredContactMethodEnum.Phone]: 'Phone',
    [PreferredContactMethodEnum.Email]: 'Email',
    [PreferredContactMethodEnum.Text]: 'Text',
    [PreferredContactMethodEnum.Teams]: 'Teams',
  };

const contactForLabels: Record<PrimaryContactForEnum, string> = {
  [PrimaryContactForEnum.Pricing]: 'Pricing',
  [PrimaryContactForEnum.Contracts]: 'Contracts',
  [PrimaryContactForEnum.Onboarding]: 'Onboarding',
  [PrimaryContactForEnum.Timekeeping]: 'Timekeeping',
  [PrimaryContactForEnum.CustomerEscalations]: 'Customer Escalations',
  [PrimaryContactForEnum.WorkerEscalations]: 'Worker Escalations',
  [PrimaryContactForEnum.Invoicing]: 'Invoicing',
  [PrimaryContactForEnum.ProfitReporting]: 'Profit Reporting',
  [PrimaryContactForEnum.Collections]: 'Collections',
  [PrimaryContactForEnum.Technology]: 'Technology',
  [PrimaryContactForEnum.Implementation]: 'Implementation',
};

export const getContactForOptions = () =>
  ALL_CONTACT_FOR_VALUES.map((value) => ({
    label: contactForLabels[value],
    value,
  }));

export const isAllContactForSelected = (
  values?: PrimaryContactForEnum[] | null,
): boolean => {
  if (!values?.length) {
    return false;
  }

  return (
    values.length === ALL_CONTACT_FOR_VALUES.length &&
    ALL_CONTACT_FOR_VALUES.every((value) => values.includes(value))
  );
};

export const handleContactForSelectChange = (
  selected: PrimaryContactForEnum[],
  setValue: (value: PrimaryContactForEnum[]) => void,
): void => {
  const allUiValue = CONTACT_FOR_ALL_UI_VALUE as PrimaryContactForEnum;
  const withoutAllUiValue = selected.filter((value) => value !== allUiValue);

  if (selected.includes(allUiValue)) {
    setValue([...ALL_CONTACT_FOR_VALUES]);
    return;
  }

  setValue(withoutAllUiValue);
};

export const sanitizeContactForForRequest = (
  values?: PrimaryContactForEnum[] | null,
): PrimaryContactForEnum[] | undefined => {
  const sanitizedValues = (values ?? []).filter((value) =>
    ALL_CONTACT_FOR_VALUES.includes(value),
  );

  return sanitizedValues.length ? sanitizedValues : undefined;
};

export const getPreferredContactMethodLabel = (
  values?: PreferredContactMethodEnum[] | null,
): string | undefined => {
  if (!values?.length) return undefined;

  return values
    .map((item) => preferredContactMethodLabels[item])
    .filter(Boolean)
    .join(', ');
};

export const getContactForLabel = (
  values?: PrimaryContactForEnum[] | null,
): string | undefined => {
  if (!values?.length) return undefined;

  return values
    .map((item) => contactForLabels[item])
    .filter(Boolean)
    .join(', ');
};
